<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :style="value >= 0 ? '' : 'transform: rotate(180deg)'"
  >
    <path
      d="M6.99328 5.86688L5.67995 7.18021L3.53995 9.32021C3.09328 9.77354 3.41328 10.5469 4.05328 10.5469L8.20662 10.5469L11.9466 10.5469C12.5866 10.5469 12.9066 9.77354 12.4533 9.32021L8.99995 5.86687C8.45328 5.31354 7.54662 5.31354 6.99328 5.86688Z"
      :fill="value >= 0 ? '#00925E' : '#C21D1D'"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  value: {
    type: Number,
    default: 0,
  },
  width: {
    type: [String, Number],
    default: 16,
  },
  height: {
    type: [String, Number],
    default: 16,
  },
});
</script>
